﻿( function( doc ) {
	'use strict';

    const NUMTOLOAD = 10;

    class EventViewPage {

        constructor() {
            this.sectionPrograms = app.$( '.programs' );
        	this.progContainer = app.$( '#program-container' );
            this.filterBoxArea = app.$( '#filter-box-area' );
            this.startDate = moment().format( 'MM/DD/YYYY' );
            this.endDate = moment().add( 6, 'M' ).format( 'MM/DD/YYYY' );
        	this.btnLoadMore = app.$( '#btn-load-more' );
        	this.btnLaunch = app.$( '#bt-open-filter' );
            this.eventIdx = [];
            this.lastIdx = -1;
            this.curMonthCode = '';
            this.bindFilterEvents();
            this.loadIndex();
            this.topOfFilterBox = this.filterBoxArea.getBoundingClientRect().top; 
            this.bindLaunch();
        }

        bindFilterEvents() {
            new app.Form( this.filterBoxArea );

            app.$.fetch( 'api/membership/userAuthenticate', {
    			credentials: 'include',
    			body: {
    				roleId: 2
    			}
    		}).then(rsp => {
    			if (rsp.success) {
    				document.body.classList.add('logged-in');
    			} else {
    				console.log(rsp.msg);
    			}
    		});

        	const btnClear = app.$( '#btn-clear-filter' );
            const btnfilterClose = app.$( '#btn-box-close' );
            this.btnApply = app.$( '#btn-apply-filter' );
            this.tbStartDate = app.$( '#tb-startDate' );
            this.tbEndDate = app.$( '#tb-endDate' );

        	if ( btnfilterClose ) {
        		btnfilterClose.addEventListener( 'click', e => {
        			doc.body.classList.remove( 'nav-in' );
        			doc.body.classList.toggle( 'filter-in' );
        		} );
        	}
           
            window.addEventListener( 'scroll', e => {
                const y = app.util.getWindowScrollPosition();

                //let newTopMargin = y - this.topOfFilterBox;

                //if ( newTopMargin < 0 ) {
                //    newTopMargin = 0;
                //}

                //if ( newTopMargin > 0 && this.progContainer.offsetHeight > this.filterBoxArea.offsetHeight ) {
                //    this.filterBoxArea.classList.add( 'fixed' );
                //} else {
                //    this.filterBoxArea.classList.remove( 'fixed' );
                //}
  
                // Auto load more content on scroll
                if ( this.lastEventItem && !this.loadingEvents ) {
                    if ( y + window.innerHeight >= this.lastEventItem.offsetTop ) {
                        this.loadList( false );
                    }
                }
            } );


            if ( this.btnLoadMore ) {
                this.btnLoadMore.addEventListener( 'click', e => {
                    this.loadList(false);
                });
            }

            if ( this.tbEndDate ) {
                this.tbEndDate.addEventListener( 'blur', e => {
                    const errorMsg = app.$( '.error-msg' );
  
                    if ( this.tbEndDate.value < this.tbStartDate.value ) {
                        errorMsg.classList.remove( 'hidden' );
                        this.tbEndDate.classList.add( 'form-error' );
                        this.btnApply.disabled = true;
                        this.btnApply.classList.add( 'btn-fail' );
                    } else {
                        errorMsg.classList.add( 'hidden' );
                        this.tbEndDate.classList.remove( 'form-error' );
                        this.btnApply.disabled = false;
                        this.btnApply.classList.remove( 'btn-fail' );
                    }
                } );
            }

            if ( btnClear ) {

                btnClear.addEventListener( 'click', e => {
                    app.$.fetch( 'api/programEventFitlerBoxGet', {}).then( rsp => {

                        if ( rsp.success ) {
                            this.filterBoxArea.innerHTML = rsp.obj;
                            this.bindFilterEvents();
                            this.loadIndex();
                        } else {
                            console.log( rsp.msg );
                        }

                        window.scrollTo( 0, 0 );
                    });

                });
            }

            if ( this.btnApply ) {

                this.btnApply.addEventListener( 'click', e => {
                    //collect filter settings


                    const ddProvider = app.$( '#dd-provider' ),
                          gradeArea = app.$( '#grade-filter' ),
                          contentArea = app.$( '#content-filter' ),
                          searchStr = app.$( '#tb-searchStr' );

                    let grades = '',
                        contents = '';

                    app.$$('input[type="checkbox"]:checked', gradeArea).forEach(el => { 
                        grades += el.value + ',';
                    });

                    app.$$('input[type="checkbox"]:checked', contentArea).forEach(el => {
                        contents += el.value + ',';
                    } );

                    if ( this.tbStartDate.value === '' || this.tbEndDate.value === '' ) {
                        this.tbStartDate.value = this.startDate;
                        this.tbEndDate.value = this.endDate;
                    }
          
                    const filter = {
                        providerId: ddProvider.value,
                        startDate: this.tbStartDate.value,
                        endDate: this.tbEndDate.value,
                        grades: grades,
                        contents: contents,
                        searchStr: searchStr.value
                    };

                    requestAnimationFrame( _ => {
                        this.loadIndex( filter );
                        doc.body.classList.remove( 'filter-in' );
                        window.scrollTo( 0, 0 );
                    } );

                });
            }
        }

        loadList( cleanContainer ) {

            //First we need to build a list of the next needed events
            if ( this.lastIdx < this.eventIdx.length ) {

                let cntr = 1,
                    neededEvents = [],
                    insertMonthBefore = [];

                //Build list of needed events to pass to web service
                while ( this.lastIdx < this.eventIdx.length - 1 ) {

                    this.lastIdx += 1;
                    neededEvents.push( this.eventIdx[this.lastIdx].eventId );

                    if ( this.eventIdx[this.lastIdx].monthCode !== this.curMonthCode ) {
                        insertMonthBefore.push( this.eventIdx[this.lastIdx].eventId );
                        this.curMonthCode = this.eventIdx[this.lastIdx].monthCode;
                    }
                    cntr += 1;
                    if (cntr > NUMTOLOAD) {
                        break;
                    }
                }
                if ( neededEvents.length > 0 ) {
                	this.loadingEvents = true;

                    try {

                        app.$.fetch( 'api/eventsGetForView', {
                            body: {
                                events: neededEvents
                            }
                        }).then( rsp => {

                            if ( rsp.success ) {
                                const displayEvents = rsp.obj;

                                if ( cleanContainer ) {
                                    this.progContainer.innerHTML = '';
                                }

                                for ( let i = 0; i < displayEvents.length; i++ ) {
                                    let evt = displayEvents[i];
                                    //Check to see if we need to insert the Month before current event
                                    let idxBefore = insertMonthBefore.indexOf( evt.eventId );

                                    if ( idxBefore > -1 ) {
                                        // need to insert month header, find the event in the EventList to get month display string.

                                        for ( let cnt = 0; cnt < this.eventIdx.length; cnt++ ) {
                                            let e = this.eventIdx[cnt];
                                            if ( e.eventId === insertMonthBefore[idxBefore] ) {
                                                let monthHeadDisplay = doc.createElement( 'div' );
                                                monthHeadDisplay.textContent = e.monthDisplay;
                                                monthHeadDisplay.classList.add( 'event-view-month-head' );
                                                this.progContainer.appendChild( monthHeadDisplay );
                                                //break;
                                            }
                                        }
                                    }

                                    //dislay the event on page
                                    this.oneEventContainer = doc.createElement( 'div' );
                                    this.oneEventContainer.innerHTML = evt.html;
                                    this.oneEventContainer.classList.add( 'event-item' );

                                    this.progContainer.appendChild( this.oneEventContainer );
                                    let a = new app.EventItem( evt.eventId, this.oneEventContainer );
                                    if ( i + 1 === displayEvents.length ) {
                                        requestAnimationFrame( _ => { this.lastEventItem = this.oneEventContainer; });

                                        // Display FREE when they enter 0 as Cost
                                        //const costValue = app.$$( '.cost-val' );
                                        //costValue.forEach( el => {
                                        //    if ( el.innerHTML.indexOf( '$0' ) === 0 || el.innerHTML.indexOf( '0' ) === 0 ) {
                                        //        el.innerHTML = 'FREE';
                                        //    }
                                        //} );

                                        // Toggle usages of Registration button based on Max Sites and Deadline
                                        const btnReg = app.$$( '.reg-closed' );
                                        btnReg.forEach( el => {
                                            el.innerHTML = 'Closed';
                                        } ); 
                                    }
                                } // end of event list loop

                                const cbFree = app.$( '#cb-free' );
                                const cbOpen = app.$( '#cb-open' );
                                const evtItems = app.$$( '.event-item' );
                                const evtRow = app.$$( '.event-view-row ' );
                                
                                if ( cbFree.checked ) {
                                    evtItems.forEach( evt => {
                                        const cost = app.$( '.cost-val', evt );
  
                                        if ( cost.textContent === '$FREE' || cost.textContent === 'FREE' ) {
                                            evt.classList.add( 'free' );
                                        } else {
                                            evt.classList.add( 'not-free' );
                                        }
                                    } );
                                }

                                if ( cbOpen.checked ) {
                                    evtRow.forEach( row => {
                                        if ( row.classList.contains( 'closed' ) ) {
                                            row.parentElement.classList.add( 'hidden' );
                                        } 
                                    } );
                                }

                                this.btnLoadMore.classList.remove( 'hidden' );

                            } else {
                                console.log( rsp.msg );
                            }

                            this.loadingEvents = false;

                        });

                    }
                    catch ( err ) {
                        this.progContainer.innerHTML = 'Load Error.  Refresh page or hit the "Apply" filter button again to correct the problem.';
                        this.loadingEvents = false;
                        console.log( err );
                    }
                }

                if ( neededEvents.length < NUMTOLOAD ) {
                    this.btnLoadMore.classList.add( 'hidden' );
                }

            } else {
                this.btnLoadMore.classList.add( 'hidden' );
            }
        }

        toggleRegisterBtn() {
        	
        }

        loadIndex( filter ) {

            if ( !filter ) {
                filter = {
                    providerId: -1,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    grades: '',
                    contents: '',
                    searchStr: ''
                };
            }

            this.btnLoadMore.classList.add( 'hidden' );
           // this.progContainer.innerHTML = '<div class="hollow-dots-spinner" :style="spinnerStyle"><div class="dot"></div><div class="dot"></div><div class="dot"></div></div>';
            this.curMonthCode = '';

            app.$.fetch( 'api/eventsGetFiltered', {
                body: {
                    filter: JSON.stringify( filter )
                }
            }).then( rsp => {
                if ( rsp.success ) {
                    this.lastIdx = -1;
                    this.eventIdx = rsp.obj;      

                    if ( this.eventIdx.length > 0 ) {
                        this.progContainer.innerHTML = '<div class="hollow-dots-spinner" :style="spinnerStyle"><div class="dot"></div><div class="dot"></div><div class="dot"></div></div>';
                        this.loadList( true );
                    }
                    else {
                        this.progContainer.innerHTML = 'No scheduled events available.';
                    }
            
                } else {
                    console.log( rsp.msg );
                }
            });
        }

        bindLaunch() {
        	if ( this.btnLaunch ) {
        		this.btnLaunch.addEventListener( 'click', e => {
        			doc.body.classList.toggle( 'filter-in' );
        		} );
        	}
        }
    }

    let pg = new EventViewPage();

})( document );